import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const putTags = (params) => {
    return axios.put(`${backendHost}/api/admin/users/tags`, params);
};